/**
 * Shared reducer
 * @namespace shared_reducer
 * @category Redux
 * @subcategory Reducers
 */
// eslint-disable-next-line
const shared_reducer = {};
//used for the namespace in the documentation

if (
  !window.localStorage.getItem("mapName") &&
  !window.localStorage.getItem("mapURL") &&
  !window.localStorage.getItem("mapAttribution")
) {
  window.localStorage.setItem("mapName", "arcgisonlineLight");
  window.localStorage.setItem(
    "mapURL",
    "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
  );
  window.localStorage.setItem(
    "mapAttribution",
    `&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors`
  );
}

/**
 * The initial shared state
 * @memberof shared_reducer
 */
const initState = {
  loading: true,
  readyWebsocketData: false,
  readyStaticData: false,
  isMapDialogOpen: false,
  mapDialogData: null,
  isDrawerOpen: false,
  selectedLine: null,
  selectedNavigationTab: "PUBLIC_TRANSIT",
  mapBaselayer: {
    name: window.localStorage.getItem("mapName"),
    url: window.localStorage.getItem("mapURL"),
    attribution: window.localStorage.getItem("mapAttribution"),
  },
  disableWheelZoom: true,
  mapCenter: [42.696889, 23.320856],
  mapZoom: 12,
};

/**
 * Redux shared reducer
 * @category Redux
 * @subcategory Reducers
 * @memberof shared_reducer
 * @function sharedReducer
 * @param {object} state the state of the reducer
 * @param {object} action the actions for the reducer
 */
const sharedReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_READY_WEBSOCKET_DATA":
      return {
        ...state,
        readyWebsocketData: action.payload,
      };
    case "SET_READY_STATIC_DATA":
      return {
        ...state,
        readyStaticData: action.payload,
      };
    case "SET_MAP_DIALOG":
      return {
        ...state,
        isMapDialogOpen: action.payload,
      };
    case "SET_MAP_DIALOG_DATA":
      return {
        ...state,
        mapDialogData: action.payload,
      };
    case "SET_IS_DRAWER_OPEN":
      return {
        ...state,
        isDrawerOpen: action.payload,
      };
    case "SET_SELECTED_LINE":
      return {
        ...state,
        selectedLine: action.payload,
      };
    case "SET_SELECTED_NAVIGATION_TAB":
      return {
        ...state,
        selectedNavigationTab: action.payload,
      };
    case "DISABLE_WHEEL_ZOOM":
      return {
        ...state,
        disableWheelZoom: action.payload,
      };
    case "SET_MAP_BASELAYER":
      return {
        ...state,
        mapBaselayer: action.payload,
      };
    case "CHANGE_MAP_CENTER":
      return {
        ...state,
        mapCenter: action.payload,
      };
    case "SET_MAP_ZOOM":
      return {
        ...state,
        mapZoom: action.payload,
      };
    default:
      return state;
  }
};

export default sharedReducer;
